// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewRequestButton {
  color: #008080 !important;
  box-shadow: none !important;
  border-color: #008080 !important;
  background-color: #ffffff !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  text-transform: unset !important;
}

.viewRequestButton:hover {
  background-color: #006666 !important;
  color: #ffffff !important;
}

.make-request-btn {
  color: #ffffff !important;
  box-shadow: none !important;
  /* border-color: #008080 !important; */
  background-color: #008080 !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  text-transform: unset !important;
  min-width: 11.5em !important;
}

.make-request-btn:hover {
  background-color: #006666 !important;
  color: #ffffff !important;
}

.make-request-btn:disabled {
  color: #a5a5a5b5 !important;
  border: 1px solid rgb(236, 236, 236) !important;
  box-shadow: none !important;
  text-transform: unset !important;
  background-color: rgba(0, 0, 0, 0.04) !important;
  font-weight: 400 !important;
  padding: 5px;
  letter-spacing: 0.5px;
  font-size: 12px !important;
}

.thickerLoader {
  stroke-width: 4
}`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/UserActions/UserActions.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;EACtC,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,2BAA2B;EAC3B,gCAAgC;EAChC,gDAAgD;EAChD,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;AACF","sourcesContent":[".viewRequestButton {\n  color: #008080 !important;\n  box-shadow: none !important;\n  border-color: #008080 !important;\n  background-color: #ffffff !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  text-transform: unset !important;\n}\n\n.viewRequestButton:hover {\n  background-color: #006666 !important;\n  color: #ffffff !important;\n}\n\n.make-request-btn {\n  color: #ffffff !important;\n  box-shadow: none !important;\n  /* border-color: #008080 !important; */\n  background-color: #008080 !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  text-transform: unset !important;\n  min-width: 11.5em !important;\n}\n\n.make-request-btn:hover {\n  background-color: #006666 !important;\n  color: #ffffff !important;\n}\n\n.make-request-btn:disabled {\n  color: #a5a5a5b5 !important;\n  border: 1px solid rgb(236, 236, 236) !important;\n  box-shadow: none !important;\n  text-transform: unset !important;\n  background-color: rgba(0, 0, 0, 0.04) !important;\n  font-weight: 400 !important;\n  padding: 5px;\n  letter-spacing: 0.5px;\n  font-size: 12px !important;\n}\n\n.thickerLoader {\n  stroke-width: 4\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
